import { Link } from "react-router-dom";

// Co-branded lockup: colored Eagle 1 logo + Cessna Pilot Center, on a clean
// white plate so it reads on any background (dark hero, glass nav, dark footer).
export const BrandLockup = ({ eagleH = "h-10", cpcH = "h-9", className = "" }) => (
  <div className={`inline-flex items-center gap-3 rounded-xl bg-white backdrop-blur-sm px-3 py-1.5 shadow-[0_6px_22px_rgba(22,66,117,0.20)] ${className}`} data-testid="brand-logo">
    <img src="/img/logo.png" alt="Eagle 1 Flight Academy" className={`${eagleH} w-auto object-contain`} loading="eager" />
    <span className="flex items-center gap-2 sm:gap-3">
      <span className="w-px h-7 sm:h-8 bg-[var(--line)]" />
      <img src="/img/cpc.webp" alt="Cessna Pilot Center — Certified" className={`${cpcH} w-auto object-contain`} loading="eager" />
    </span>
  </div>
);

// Kept for backward-compat where a plain logo is needed.
export const Logo = ({ light = false, className = "", size = "h-11" }) => (
  <div className={`flex items-center ${className}`} data-testid="brand-logo">
    <img src={light ? "/img/logo_white.png" : "/img/logo.png"} alt="Eagle 1 Flight Academy" className={`${size} w-auto object-contain`} loading="eager" />
  </div>
);
